<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">
        <div class="container grid grid-cols-1 md:grid-cols-2 gap-3 pt-4">
            <div class="col-span-1 position-relative">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-10 ml-2">
                    {{ $t('product.manufacturerDate') }}
                </div>
                <b-form-datepicker
                    id="manufacturerDate"
                    v-model="manufacturerDate"
                    class="border-gray-300"
                    size="lg"
                    :hide-header="false"
                ></b-form-datepicker>
            </div>

            <div class="col-span-1 position-relative">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-10 ml-2" id="tooltip">
                     <span id="tooltip">{{ $t('product.expirationDate') }}</span>
                </div>
                <b-tooltip show target="tooltip" variant="info">
                    {{ $t('product.withoutExpirationDate') }}
                </b-tooltip>
                <b-form-datepicker
                    id="expirationDate"
                    v-model="expirationDate"
                    class="border-gray-300"
                    size="lg"
                    :hide-header="false"
                ></b-form-datepicker>
            </div>
        </div>

        <div class="container grid grid-cols-1 md:grid-cols-2 gap-3 mt-4">
            <div class="col-span-1 position-relative">
                <b-form-checkbox
                    size="lg"
                    v-model="hasAddPoint"
                >
                    {{ $t('product.exportBarcode') }}
                </b-form-checkbox>
            </div>

            <div class="col-span-1 position-relative">
                <b-button
                    class="float-right h-11"
                    variant="primary"
                    id="barcode"
                    @click="make"
                >
                    {{ $t('export') }}
                </b-button>
            </div>
        </div>
    </Row>
</template>

<script>
import {exportFile} from "@/store/local/exportFile";
import {mapActions, mapGetters} from "vuex";
import Row from "@/components/html/Row";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";

export default {
    name: "ExportBarcode",
    components: {Row},
    mixins: [dateFormattingMixin],
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'product.title', url: 'products'},
                {name: 'export'},
            ],
            listBarcode: [],
            fileName: null,
            manufacturerDate: null,
            expirationDate: null,
            hasAddPoint: true
        }
    },
    computed: {
        ...mapGetters(['getSelfMadeProducts'])
    },
    methods: {
        ...mapActions(['fetchSelfMadeProducts', 'setBreadcrumbItems']),
        exportData() {
            exportFile().exportDataFromJSON(this.listBarcode, this.fileName, 'txt')
            this.$root.showOverlay = false
        },
        makeBarCodeList() {
            this.listBarcode = []

            for (let product of this.getSelfMadeProducts) {
                let zero = '0'

                if (product.id.toString().length < 5) {
                    do {
                        zero = zero + '0'
                    } while ((product.id.toString().length + zero.length) < 5)
                }

                let id = zero + product.id.toString()
                let row = id + ';' + product.name + ';;' + parseFloat(product.sellingPrice) + ';0;0;0;' +
                    id + ';0;0;;' + this.dateFormat(this.manufacturerDate) + ';0;0;0;'

                if (product.productPurchases[0].shelfLife === null) {
                    row = row + this.dateFormat(this.expirationDate)
                } else {
                    row = row + this.dateFormat(product.productPurchases[0].shelfLife)
                }

                if (this.hasAddPoint) {
                    if (product.unitOfMeasure === "kg" || product.unitOfMeasure === "g") {
                        row = row + ';1\n'
                    } else {
                        row = row + ';0\n'
                    }
                } else {
                    row = row + '\n'
                }

                this.listBarcode = this.listBarcode + row
            }
        },
        async make() {
            this.$root.showOverlay = true

            await this.makeBarCodeList()
            await this.exportData()
        },
        getTodayDate(difference = 1) {
            let yearNow = new Date().getFullYear()
            let monthNow = new Date().getMonth() + difference
            let dateNow = new Date().getDate()

            return yearNow + '-' + this.addZero(monthNow) + '-' + this.addZero(dateNow)
        },
        addZero(val) {
            return val < 10 ? '0' + val : val;
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.$root.showOverlay = true
        this.manufacturerDate = this.getTodayDate()
        this.expirationDate = this.getTodayDate(3)
        this.fetchSelfMadeProducts()
            .then(() => {
                this.$root.showOverlay = false
                setTimeout(() => this.$root.$emit('bv::hide::tooltip'), 5000)
            })
    }
}
</script>

<style scoped>

</style>
